import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/star-gray.svg';
const StarGray = () => React.createElement(IconSvg, null);
export default StarGray;
